import { Button, SVG } from "shared";
import "./Hero.scss";
import { HomepageModalType } from "screens/homePage/Homepage";
import { SVG_ENUM } from "enums";
import { isDesktop } from "utils";

type HeroPageProps = {
  setModalManage: (type: HomepageModalType | null) => void;
};

const Hero: React.FC<HeroPageProps> = ({ setModalManage }) => {
  return (
    <main className="hero">
      {isDesktop() && (
        <SVG type={SVG_ENUM.HOMEPAGE_HERO_BACKGROUND} className="hero__bg" />
      )}
      <div className="layout">
        <div className="hero__left">
          <h1>
            Inteligentne inwestowanie
            <br /> <i>zaczyna się dziś</i>
          </h1>
          <p>
            Natychmiastowy dostęp do najważniejszych informacji giełdowych,
            dzięki czemu podejmowanie decyzji inwestycyjnych staje się szybsze,
            prostsze i&nbsp;bardziej świadome.
          </p>
          <Button
            styleType="primary"
            size="large"
            label="Sprawdź pakiety"
            onClick={() => setModalManage("packet")}
          />
          {!isDesktop() && <SVG type={SVG_ENUM.HOMEPAGE_HERO_BACKGROUND} />}
        </div>
        <div className="hero__right">
          {!isDesktop() && (
            <img
              className="hero__mockup-mobile"
              src={require("assets/images/HomepageHeroMockupMobile.webp")}
              alt="mobile version of dashboard"
            />
          )}
          {isDesktop() && (
            <img
              className="hero__mockup-desktop"
              src={require("assets/images/HomepageHeroMockupDesktop.webp")}
              alt="desktop version of dashboard"
            />
          )}
        </div>
      </div>
    </main>
  );
};

export default Hero;
